import React, { useContext } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { ConfigContext } from '../../../context/ConfigContext';
import useWindowSize from '../../../hooks/useWindowSize';


import NavLogo from './NavLogo';
import NavContent from './NavContent';
import navigation from '../../../menu-items';

const Navigation = () => {
  const configContext = useContext(ConfigContext);
  const { collapseMenu } = configContext.state;
  const windowSize = useWindowSize();

  let navClass = ['pcoded-navbar'];

  navClass = [...navClass];

  if (windowSize.width < 992 && collapseMenu) {
    navClass = [...navClass, 'mob-open'];
  } else if (collapseMenu) {
    navClass = [...navClass, 'navbar-collapsed'];
  }

  let navBarClass = ['navbar-wrapper'];

  const { user } = useAuth(); // ✅ Get user from context
  const role = user?.role?.toLowerCase();
  console.log(role);

  const filterMenuItemsByRole = (items, role) => {
    if (role === 'super_admin' || role === 'super admin' || role === 'admin') return items;
    return items
      .map(item => {
        const hasRole = !item.roles || item.roles.includes(role);

        if (item.children) {
          const filteredChildren = filterMenuItemsByRole(item.children, role);
          if (hasRole || filteredChildren.length > 0) {
            return { ...item, children: filteredChildren };
          }
          return null;
        }

        return hasRole ? item : null;
      })
      .filter(Boolean); // Remove nulls
  };

  // ── Demo account: the walkthrough plus the four pages it covers ──────────
  //
  // These four are served from a local dataset (see src/demo), but the rest of
  // the C&I module still hits the server, where middleware/demoAnonymizer
  // renames every client. Leaving the full menu up would let the same company
  // appear as "Power Cement" on Job History and under a scrubbed alias on the
  // dashboard — so the demo account only gets the pages that are consistent.
  const DEMO_MENU_WHITELIST = new Set([
    '/commercial/demo',
    '/commercial/attendance',
    '/commercial/team-calender',
    '/commercial/job-history',
  ]);

  const applyDemoRestriction = (items) =>
    items
      .map((item) => {
        if (item.children) {
          const children = applyDemoRestriction(item.children);
          return children.length ? { ...item, children } : null;
        }
        return DEMO_MENU_WHITELIST.has(item.url) ? item : null;
      })
      .filter(Boolean);

  // demoOnly entries are hidden from every normal account.
  const stripDemoOnly = (items) =>
    items
      .map((item) => {
        if (item.children) {
          const children = stripDemoOnly(item.children);
          return children.length ? { ...item, children } : null;
        }
        return item.demoOnly ? null : item;
      })
      .filter(Boolean);

  const isDemo = user?.is_demo === true;
  const roleFiltered = filterMenuItemsByRole(navigation.items, role);
  const filteredMenuItems = isDemo
    ? applyDemoRestriction(roleFiltered)
    : stripDemoOnly(roleFiltered);

  let navContent = (
    <div className={navBarClass.join(' ')}>
      {/* <NavLogo /> */}
      <NavContent navigation={filteredMenuItems} />
    </div>
  );
  if (windowSize.width < 992) {
    navContent = (
      <div className="navbar-wrapper">
        {/* <NavLogo /> */}
        <NavContent navigation={filteredMenuItems} />

      </div>
    );
  }
  return (
    <React.Fragment>
      <nav className={navClass.join(' ')}>{navContent}</nav>
    </React.Fragment>
  );
};

export default Navigation;
